import React from "react";

import {
    Input,
    Radio,
} from 'antd';

const {Search} = Input;

//PubSearchBlock
export default () => {

    return <>
        <Input.Group>
            <Search
                // ref={searchInputRef}
                placeholder="Search by keyword"
                allowClear
                disabled
            />
        </Input.Group>

        <Radio.Group
            buttonStyle="solid"
            value="search"
            style={{ margin: '8px 0 8px 14px' }}
            disabled
        >
            <Radio value="search">Keyword</Radio>
            <Radio value="match">Researcher</Radio>
        </Radio.Group>

    </>
}